import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
 selector: '[numbersOnly]'
})
export class NumbersOnlyDirective {
 // Allow decimal numbers and negative values
//  private regex: RegExp = new RegExp(/^-?[0-9]+(\.[0-9]*){0,1}$/g);
  // Allow numbers only
  private regex: RegExp = new RegExp(/^[0-9]*$/g);
 // Allow key codes for special events. Reflect :
 // Backspace, tab, end, home
 private specialKeys: Array<string> = [ 'Backspace', 'Tab', 'End', 'Home', 'Enter', 'Delete', 'ArrowRight', 'ArrowLeft' ];

constructor(private el: ElementRef) {
 }
 @HostListener('keydown', [ '$event' ])
 onKeyDown(event: KeyboardEvent) {
      console.log(event.key);
      if((event.ctrlKey || event.metaKey) && event.keyCode == 67) {
        return true;
      }
    if((event.ctrlKey || event.metaKey) && event.keyCode == 86) {
      return true;
    }
        console.log('CTRL +  V');
 // Allow Backspace, tab, end, and home keys
 if (this.specialKeys.indexOf(event.key) !== -1) {
 return;
 }
 let current: string = this.el.nativeElement.value;
 let next: string = current.concat(event.key);
 if (next && !String(next).match(this.regex)) {
 event.preventDefault();
 }
 }
}